import React, { useContext } from 'react';
import { ColorThemeContext } from '@shared/styles';
import { MBText, MBTextProps } from '../MBText';

interface MBHighlightedTextProps extends Omit<MBTextProps, 'children'> {
  range: MB.Range;
  children: string;
}

export function MBHighlightedText({
  range,
  children,
  numberOfLines,
  ...otherProps
}: MBHighlightedTextProps) {
  const colors = useContext(ColorThemeContext);
  return (
    // We render everything in an MBText, which makes the
    // text segments below be placed inline. Note: when
    // supplying numberOfLines to the nested MBText, we
    // would get every text piece (pre, highlight, after)
    // on a separate line, which we don't want. Therefore
    // we only apply the numberOfLines prop to the root MBText.
    <MBText numberOfLines={numberOfLines} {...otherProps}>
      {/* 1. Render everything until the start of the highlight. This can be an empty string. */}
      {children.substring(0, range.start)}
      {/* 2. Render the highlighted part with some additional styles */}
      <MBText
        {...otherProps}
        style={[{ backgroundColor: colors.highlightActive }, otherProps.style]}
      >
        {children.substring(range.start, range.end)}
      </MBText>
      {/* 3. Render everything after the highlight. This can be an empty string. */}
      {children.substring(range.end, children.length)}
    </MBText>
  );
}
